import { FC } from "react"
import { Icon, IconColor } from "@/components/shared/Icon"
import { TestId } from "@/constants/globals"

interface ActionsProps {
   isDisabled?: boolean
   isEditing: boolean
   hasReset?: boolean
   hasDelete?: boolean
   onCancel: () => void
   onEdit: () => void
   onSave: () => void
   onReset?: () => void
   onDelete?: () => void
}

const Actions: FC<ActionsProps> = ({
   isDisabled = false,
   isEditing,
   hasReset = false,
   hasDelete = false,
   onCancel,
   onEdit,
   onSave,
   onReset,
   onDelete,
}) => {
   return (
      <div className="alert-setting__actions">
         {!isEditing ? (
            <>
               {hasReset && (
                  <Icon
                     size="16"
                     name="reset"
                     color={IconColor.HONOLULU_BLUE}
                     onClick={onReset}
                  />
               )}
               <Icon
                  size="16"
                  color={IconColor.HONOLULU_BLUE}
                  name="edit"
                  onClick={onEdit}
                  data-testid={TestId.ALERT_SETTING_EDIT_ICON}
               />
            </>
         ) : (
            <>
               <Icon
                  size="16"
                  name="cross"
                  color={IconColor.HONOLULU_BLUE}
                  onClick={onCancel}
                  data-testid={TestId.ALERT_SETTING_CANCEL_ICON}
               />
               {hasDelete && (
                  <Icon
                     size="16"
                     name="trashBin"
                     color={IconColor.CERISE}
                     onClick={onDelete}
                     data-testid={TestId.ALERT_SETTING_DELETE_ICON}
                  />
               )}
               <Icon
                  size="16"
                  name="save"
                  color={IconColor.HONOLULU_BLUE}
                  onClick={onSave}
                  disabled={isDisabled}
                  data-testid={TestId.ALERT_SETTING_SAVE_ICON}
               />
            </>
         )}
      </div>
   )
}

export default Actions
